//      
                                                        

export default function didStartAfterCritical(
  draggableId             ,
  afterCritical            ,
)          {
  return Boolean(afterCritical.effected[draggableId]);
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/did-start-after-critical.js